const pbxcdrcsvcolumndata = [
  { id: "start_stamp", title: "Time", default: true },
  { id: "caller_id_number", title: "From", default: true },
  { id: "destination_number", title: "To", default: true },
  { id: "duration", title: "Duration", default: true },
  { id: "hangup_cause", title: "Result", default: true },
];
export default pbxcdrcsvcolumndata;
